import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Col, Input, Row, Button, FormGroup, InputGroup, InputGroupText, CustomInput } from 'reactstrap';
import { countryCodes } from '../../../../../server/countryCodes';
import { useAuthState } from "../../../../../context";
import { MessageConst } from '../../../../../helpers/messageConst';


const schema = yup.object({
    id: yup.number().transform((value) => (isNaN(value) ? 0 : value)).default(0),
    vendorCode: yup.string().required('Please provide vendor code').nullable(),
    name: yup.string().required('Please provide vendor name').nullable(),
    contact: yup.string().nullable(),
    email: yup.string().email().nullable(),
    address: yup.string(),
    accountNo: yup.string(),
    active: yup.boolean().default(true)
});

const VendorForm = ({ onCancelClick, onSubmitClick, defaultValues, loading, countryCode }) => {
    const { control, register, handleSubmit, setValue, setError, formState: { errors } } = useForm({
        defaultValues,
        mode: "all",
        resolver: yupResolver(schema)
    });
 
    const isReadOnly = defaultValues?.catererId === 0;

    const onSubmit = data => {
        const submitData = { ...defaultValues, ...data };
        onSubmitClick(submitData);
    };

    return (<>
        <form key="frmVendor" className="g-3" onSubmit={(event) => {
            event.preventDefault();
            handleSubmit(onSubmit)(event);
        }}>
            <Row>
                <Col xs={6}>
                    <label className="form-label" htmlFor='vendorCode'>Vendor Code*</label>
                    <input className="form-control" id="vendorCode"
                        type="text" {...register("vendorCode")}
                        maxLength={10} autoComplete='off'
                        readOnly={isReadOnly} />
                    {errors.vendorCode && <span className='text-danger fs--2'>{errors.vendorCode.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col>
                    <label className="form-label" htmlFor='name'>Vendor Name*</label>
                    <input className="form-control" id="name"
                        type="text" {...register("name")}
                        maxLength={50} autoComplete='off'
                        readOnly={isReadOnly} />
                    {errors.name && <span className='text-danger fs--2'>{errors.name.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col>
                    <label className="form-label" htmlFor='email'>Email Id</label>
                    <input className="form-control" id="email"
                        type="email" {...register("email")}
                        maxLength={50} autoComplete='off'
                        readOnly={isReadOnly} />
                    {errors.email && <span className='text-danger fs--2'>{errors.email.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col>
                    <label className="form-label" htmlFor='contact'>Mobile No</label>
                    <InputGroup>
                        <InputGroupText>
                            {countryCode}
                        </InputGroupText>
                        <input className="form-control" id="contact"
                            type="text" {...register("contact")}
                            maxLength={10} autoComplete='off' 
                            readOnly={isReadOnly}/>
                    </InputGroup>
                    {errors.contact && <span className='text-danger fs--2'>{errors.contact.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <label className="form-label" htmlFor='accountNo'>Account No</label>
                    <input className="form-control" id="accountNo"
                        type="text" {...register("accountNo")}
                        maxLength={10} autoComplete='off'
                        readOnly={isReadOnly} />
                    {errors.accountNo && <span className='text-danger fs--2'>{errors.accountNo.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col>
                    <label className="form-label" htmlFor='address'>Address</label>
                    <textarea className="form-control" id="address"
                        type="text" {...register("address")}
                        autoComplete='off'
                        readOnly={isReadOnly} ></textarea>
                    {errors.address && <span className='text-danger fs--2'>{errors.address.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='ml-2 mt-2'>
                    <Controller control={control} name="active"
                        id="active" {...register("active")}
                        render={({ field }) => {
                            return <><CustomInput
                                type="switch"
                                onChange={field.onChange}
                                checked={field.value}
                                innerRef={field.ref}
                                id={field.name}
                                label={field.value ? "Active" : "In-Active"}
                                {...field}
                                disabled={isReadOnly}
                            /></>
                        }}
                    />
                </Col>
            </Row>


            <Row className='flex-between-center mt-3'>
                <Col xs={'auto'}>
                  {isReadOnly ? (
                                <button className="btn btn-danger btn-sm" type="button" onClick={onCancelClick}>Close</button>
                                 ) : (<>
                                <button className="btn btn-danger btn-sm" type="button" onClick={onCancelClick}>Cancel</button>
                                </>
               )}
                </Col>
                {!isReadOnly && (
                    <Col xs={'auto'}>
                        <Button color="primary" size='sm' type="submit" disabled={loading}>Save</Button>
                    </Col>
         )}
            </Row>
        </form>
    </>)

}
export default VendorForm;